export default __webpack_public_path__ + "static/media/hot-chocolate.136d2112.png";